// useExcelExport.js
import { useCallback } from "react";
import * as XLSX from "xlsx";

const useExport = () => {
  const generateExcelFile = useCallback(() => {
    // Crea el workbook y la hoja de trabajo
    const workbook = XLSX.utils.book_new();

    // Define los encabezados de las columnas
    const headers = [
      "Número de Lote",
      "Superficie",
      "Tipo",
      "Costo",
      "Manzana"
    ];

    const worksheet = XLSX.utils.json_to_sheet([headers]);
    // Agrega el layout a la hoja de trabajo
    XLSX.utils.book_append_sheet(workbook, worksheet, "Layout");

    // Descarga el archivo
    XLSX.writeFile(workbook, "Exportacion de Lotes.xlsx");
  }, []);

  return { generateExcelFile };
};

export default useExport;
